import moment from 'moment';
import { BaseGraphTransformer } from './BaseGraphTransformer';

// eslint-disable-next-line max-len
export class ReadinessSurveyAthleteGraphTransformer extends BaseGraphTransformer {
    constructor(params) {
        super(params);
    }

    getProps() {
        this.graphProps.chartType = 'bar';
        this.graphProps.axis.y = {
            min: 0,
            max: 5,
            padding: 0,
            tick: { count: 6 }
        };

        return this.graphProps;
    }

    transformData(data) {
        const valuesObject = this.convertArrayToObject(data);
        const dateKeys = Object.keys(valuesObject);
        const valuesArray = [];

        dateKeys.forEach(date => {
            if (valuesObject[date].length > 1) {
                const filteredOutNullReadiness = valuesObject[date].filter(
                    elem => elem.readiness
                );

                valuesArray.push(filteredOutNullReadiness[0]);
            } else {
                valuesArray.push(valuesObject[date][0]);
            }
        });

        const xValues = valuesArray.map(obj =>
            moment(obj.dateCompleted).format('YYYY-MM-DD')
        );

        const yValues = valuesArray.map(obj => obj.readiness);

        return {
            graphProps: this.getProps(),
            xValues: ['xValues', ...xValues],
            yValues: ['Readiness', ...yValues]
        };
    }

    convertArrayToObject(data) {
        return data.reduce((accumulator, element) => {
            const readinessDate = moment(element.date_completed).format(
                'YYYY-MM-DD'
            );

            const readinessObject = {
                dateCompleted: element.date_completed,
                readiness: element.readiness
            };

            if (!accumulator[readinessDate]) {
                accumulator[readinessDate] = [];
            }
            accumulator[readinessDate].push(readinessObject);
            return accumulator;
        }, {});
    }
}
